import React from 'react';

import { Modal } from '../../components';
import SectionReviews from './SectionReviews';
import InquiryForm from './InquiryForm/InquiryForm';

import css from './ListingPage.module.css';

/**
 * Full-width listing sections below the two-column layout (reviews).
 * Inquiry modal stays here so OrderPanel "Message Owner" still works.
 *
 * @component
 */
const ListingPageBelowFold = props => {
  const {
    title,
    reviews,
    fetchReviewsError,
    authorDisplayName,
    isAuthenticated,
    inquiryModalOpen,
    onCloseInquiryModal,
    sendInquiryError,
    sendInquiryInProgress,
    onSubmitInquiry,
    onManageDisableScrolling,
  } = props;

  return (
    <>
      <SectionReviews reviews={reviews} fetchReviewsError={fetchReviewsError} />

      <Modal
        id="ListingPage.inquiry"
        contentClassName={css.inquiryModalContent}
        isOpen={isAuthenticated && inquiryModalOpen}
        onClose={onCloseInquiryModal}
        usePortal
        onManageDisableScrolling={onManageDisableScrolling}
      >
        <InquiryForm
          className={css.inquiryForm}
          submitButtonWrapperClassName={css.inquirySubmitButtonWrapper}
          listingTitle={title}
          authorDisplayName={authorDisplayName}
          sendInquiryError={sendInquiryError}
          onSubmit={onSubmitInquiry}
          inProgress={sendInquiryInProgress}
        />
      </Modal>
    </>
  );
};

export default ListingPageBelowFold;
